<div #edit_container data-testid="edit_container" class="container-popup">
  <div class="ui-g-12 p-0">
    <h2>{{ 'campaign.header' | translate }} <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">
    <app-form-fields #campaign_name data-testid="campaign_name" [(fieldModel)]="fieldModel.campaign_name" [type]="'string'"
    [label]="'campaign.name' | translate" [name]="'campaign_name'" [optionLabel]="'name'"
    [placeholder]="'campaign.enter_campaign_name' | translate" [required]="true"></app-form-fields>

  </div>
  <div class="ui-g-12 p-0">
    <app-form-fields #campaign_description data-testid="campaign_description" [(fieldModel)]="fieldModel.campaign_description" [required]="true"
    [type]="'textarea'" [label]="'campaign.description' | translate" [name]="'campaign_description'" [optionLabel]="'description'"
    [placeholder]="'campaign.enter_campaign_description' | translate"></app-form-fields>

  </div>

  <div class="ui-g-12 p-0">
    <h2>{{ 'campaign.campaign_validity_period' | translate }} <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">
    <div class="ui-g-6" *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">

      <app-form-fields #start_date data-testid="start_date" [showRequiredAsterix]="true" [label]="'campaign.start_date' | translate" [required]="true"
      [(fieldModel)]="fieldModel.start_date" [type]="'date'"
      [placeholder]="'campaign.select_start_date' | translate"></app-form-fields>

    </div>

    <div class="ui-g-6"  *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
      <app-form-fields #end_date data-testid="end_date" [showRequiredAsterix]="true" [label]="'campaign.end_date' | translate" [required]="true"
      [(fieldModel)]="fieldModel.end_date" [type]="'date'"
      [placeholder]="'campaign.select_end_date' | translate"></app-form-fields>

    </div>

  </div>
  <div>
  </div>
  <div class="ui-g-12 p-0">
    <h2>{{ 'campaign.type' | translate }}<span class="mandatory">*</span></h2>
  </div>

  <div class="ui-g-12 p-0">

    <div class="ui-g-6">
      <app-form-fields #campaign_type data-testid="campaign_type" [(fieldModel)]="fieldModel.campaign_type" [type]="'dropdown'"
      [options]="campaignTypeList" [optionLabel]="'label'" 
      [placeholder]="'campaign.select_campaign_type' | translate"
      [required]="true" [label]="'campaign.type' | translate"></app-form-fields>

    </div>

    <div class="ui-g-6 d-flex justify-content-center align-items-center flex-column">
      <h2 for="status">{{ 'campaign.status' | translate }}</h2>
      <span>{{this.fieldModel.status.label}}</span>
    </div>

  </div>

  <div class="ui-g-12 p-0">
    <h2>{{ 'campaign.campaign_budget' | translate }} <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">

    <div class="ui-g-6" style="padding-top: 11px;">
      <app-form-fields #budget_type data-testid="budget_type" [(fieldModel)]="fieldModel.budget_type" [type]="'dropdown'"
      [label]="'campaign.budget_type' | translate" [options]="budgetTypeList" [name]="'budget_type'" [optionLabel]="'label'"
      [placeholder]="'campaign.select_budget_type' | translate"></app-form-fields>

    </div>

    <!-- TODO aggiungere simbolo di euro permanente non come placehoder -->
    <div class="ui-g-6" style="margin-top: 4px;">
      <app-form-fields #budget_value data-testid="budget_value" [(fieldModel)]="fieldModel.budget_value" [name]="'budget_value'" [step]="100"
      [label]="'campaign.budget_value' | translate" [type]="'number'" [required]="true"></app-form-fields>

    </div>

  </div>

  <div class="ui-g-12  d-flex justify-content-center edit-btn-container">
    <button class="btn-edit-footer" data-testid="common_cancel" (click)="onClosePopup()">{{'common.cancel' | translate}}</button>
    <button class="btn-edit-footer" data-testid="common_edit" (click)="onEditData()">{{'common.edit' | translate}}</button>
  </div>



</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/edit-campaign-3/edit-campaign-3.component.html